var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9.16675C19.5 7.44284 18.8152 5.78954 17.5962 4.57055C16.3772 3.35157 14.7239 2.66675 13 2.66675C11.2761 2.66675 9.62279 3.35157 8.40381 4.57055C7.18482 5.78954 6.5 7.44284 6.5 9.16675C6.5 16.7501 3.25 18.9167 3.25 18.9167H22.75C22.75 18.9167 19.5 16.7501 19.5 9.16675Z",
    stroke: "#141414",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8743 23.25C14.6838 23.5783 14.4105 23.8509 14.0816 24.0403C13.7526 24.2298 13.3797 24.3295 13.0001 24.3295C12.6206 24.3295 12.2476 24.2298 11.9187 24.0403C11.5898 23.8509 11.3164 23.5783 11.126 23.25",
    fill: "#625F6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8743 23.25C14.6838 23.5783 14.4105 23.8509 14.0816 24.0403C13.7526 24.2298 13.3797 24.3295 13.0001 24.3295C12.6206 24.3295 12.2476 24.2298 11.9187 24.0403C11.5898 23.8509 11.3164 23.5783 11.126 23.25",
    stroke: "#141414",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon_notification.4c9ef0cee295a247b900c02512bea30f.svg";
export { ForwardRef as ReactComponent };